export default class APIHeaders {

    // Type Guard
    // TODO: 値のバリデーションを実装
  public static isAPIHeaders = (item: any): item is APIHeaders => {
    return item.Authorization != null
        && item.Locale != null
        && item['Application-version'] != null
        && item.Termname != null
        && item.Os != null
        && item.Devicename != null
        && item.Deviceidentifier != null
        && item['Content-Type'] != null
  }

  public 'Authorization' ?: string = undefined
  public 'Locale' ?: string = undefined
  public 'Application-version' ?: string = undefined
  public 'Termname' ?: string = undefined
  public 'Os' ?: string = undefined
  public 'Devicename' ?: string = undefined
  public 'Deviceidentifier' ?: string = undefined
  public 'Content-Type': string = 'application/json'
}
